import styled, { css } from 'styled-components';
import { BoxWrapperProps } from './boxwrapper.interface';

const BoxWrapper = styled.div<BoxWrapperProps>`
  ${({ theme: { space }, gap }) => css`
    width: 100%;

    &:not(&:last-child) {
      margin-bottom: ${gap ? space[gap] : space.md};
    }
  `}
`;

BoxWrapper.defaultProps = {
  gap: 'md',
};

export default BoxWrapper;
